let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("fliVL"), load("4tlRi")]).then(() => parcelRequire('5LmZi'));